var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.556c-4.178 0-7.556-3.378-7.556-7.556S7.822 4.444 12 4.444 19.556 7.822 19.556 12 16.178 19.556 12 19.556zm0 0c4.178 0 7.556-3.378 7.556-7.556S16.178 4.444 12 4.444 4.444 7.822 4.444 12 7.822 19.556 12 19.556zm0-12v6.222m0 1.778v.888",
    stroke: "#DF3131",
    fill: "none",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cg stroke='%23DF3131'%3E %3Cg%3E %3Cg%3E %3Cg%3E %3Cg%3E %3Cpath d='M8 15.556C3.822 15.556.444 12.178.444 8S3.822.444 8 .444 15.556 3.822 15.556 8 12.178 15.556 8 15.556zm0 0c4.178 0 7.556-3.378 7.556-7.556S12.178.444 8 .444.444 3.822.444 8 3.822 15.556 8 15.556zM8 3.556L8 9.778M8 11.556L8 12.444' transform='translate(-749 -300) translate(250 264) translate(0 28) translate(499 8) translate(4 4)'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgError as ReactComponent };